import { getLatestBuild } from '../../../../../../common/build-utils';
import { generateSubmissionPortalPreviewRoute } from '../../QATool/helpers/preview-helpers';
import { submissionToUpdateGraphQLInput } from '../../SubmitGame/submission-helpers';
import { BaseFormData } from '../GameBaseForm/baseFormHelper';
import { DetailsFormData } from '../GameDetailsForm/detailsFormHelper';
import { Submission } from '../submission-graphql';

export const createIframeUpdate = async (
  submission: Submission,
  baseForm: BaseFormData,
  detailsForm: DetailsFormData,
  setIsSaving: (isSaving: boolean) => void,
  updateSubmission: (input: any) => Promise<any>,
) => {
  setIsSaving(true);
  try {
    const updateInput = submissionToUpdateGraphQLInput(submission!, 'iframe', baseForm!, submission?.categoryId ? detailsForm : undefined);
    const res = await updateSubmission(updateInput);
    const newSubmission = res.data?.developerSubmissionUpdate;
    if (newSubmission && newSubmission.gameBuilds && newSubmission.gameBuilds.length > 0) {
      const latestBuild = getLatestBuild(newSubmission.gameBuilds);
      goToQA(submission, latestBuild.id);
    }
  } catch (e) {
    console.error('Error creating iframe update', e);
    setIsSaving(false);
  }
  // if everything goes fine don't setIsSaving(false), keep it loading, otherwise users manged to sneak 1 more click
  // before QA redirect and create duplicate builds in the same second
};

/**
 * In some scenarios this method was called with outdated gameBuildId, even if it was called after updating submission state in context.
 * So it requires for the new gameBuildId to be passed as an argument.
 */
export const goToQA = (submission: Submission, gameBuildId: string) => {
  if (!submission) {
    return;
  }

  const url = generateSubmissionPortalPreviewRoute(submission.id, {
    gameBuildId,
    qaTool: true,
  });
  window.location.href = url;
};
